import React, { useState } from 'react';
import { AdminLayout, TabBar } from '../components/AdminLayout';
import ProjectCreateForm from '../components/AdminForms/Project/ProjectCreateForm';
import ProjectTable from '../components/AdminForms/Project/ProjectTable';
import { ProjectDTO } from '../DTO/ProjectDTO';

const ManageProjectsPage: React.FC = () => {
    const [tab, setTab] = useState<'list' | 'create'>('list');
    const [refreshKey, setRefreshKey] = useState(0);

    const handleCreated = (_: ProjectDTO) => {
        setRefreshKey(prev => prev + 1);
        setTab('list');
    };

    return (
        <AdminLayout title="Projects">
            <TabBar
                tabs={[
                    { key: 'list',   label: `All Projects` },
                    { key: 'create', label: '+ New Project' },
                ]}
                active={tab}
                onChange={(k) => setTab(k as 'list' | 'create')}
            />
            {tab === 'list'
                ? <ProjectTable key={refreshKey} />
                : <ProjectCreateForm onCreated={handleCreated} />
            }
        </AdminLayout>
    );
};

export default ManageProjectsPage;
